import $ from 'jquery';

$(function() {
    const wrapper = document.getElementById("ds_back_link_wrapper");
    
    if (window && window.history && window.history.length > 1) {
        wrapper.style.visibility = 'visible';
    }

    const link = document.getElementById("ds_back_link_wrapper--link");
    link.addEventListener('click', (event) => {
        const customHref = link.dataset.backHref;
        if (customHref && customHref.trim().length > 0) {
            event.preventDefault();
            globalThis.location.assign(customHref);
            return;
        }
        
        event.preventDefault();
        window.history.back();
    }, false);
});